// Mixpanel retirado (ClickUp 12466mx7z8g). Se mantiene track() para no tocar sus llamadas.
const eventTracker = {
    track: () => {}
};

export default eventTracker;
